import React, { useReducer } from 'react'

import {MixerFieldTemplate, MixerNonStandard, caseFields, caseSimFields, streamFields, streamUnits, initialSetup} from './MixerFormConsts'

export const MixerDesignContext = React.createContext()

const need_date = new Date()
need_date.setDate(need_date.getDate() + 14)

const mixerFormData = {
    mixers: ['mixer1'],
    mixercount: 1,
    alertState: false,
    alertContent: "",
    alertSeverity:"success",
    isSaved: false,
    isStandard: true,
    SMVPresent: false,
    sparesPurchased: false,
    acceptTerms: false,
    quote_id: "",
    quote_name: "",
    type: "Quote",
    status: "Draft",
    issue_date: "",
    expire_date: "",
    need_date: need_date.toISOString().split('T')[0],
    last_save_date: new Date().toISOString().split('T')[0],
    add_notes: {editorHtml: ""},
    validErrors: {},
    payMethod: "ACH",
    taxExempt: false,
    bill_attn: "",
    bill_street_1: "",
    bill_street_2: "",
    bill_city: "",
    bill_st_1: "",
    bill_country: "",
    bill_postal_code: "",
    shipMethod: "Standard",
    ship_carrier: "",
    carrier_acct: "",
    ship_attn: "",
    ship_street_1: "",
    ship_street_2: "",
    ship_city: "",
    ship_st_1: "",
    ship_country: "",
    ship_postal_code: "",
    ship_phone: "",
    exportBool: false,
    exportCountry: "",
    billCopy: false,
    profileCopy: false,
    custPO: "",
    marketSegment: 'Downstream (Chemicals, Renewables, Other)',
    sulzerApplication: '',
    sulzerReview: false,
    manufactureTerms: "",
    shippingTerms: [
        {
            'description': 'Approval Drawings Submittal',
            'caption':'After receipt of formal Purchase Order and clarification of all technical and commercial matters',
            'weeks': 3
        },
        {
            'description': 'Return of Approval Drawings',
            'caption':'After submittal of drawing',
            'weeks': 2
        },
        {
            'description': 'Equipment Ready to Ship',
            'caption':'After receipt of fully approved drawing and full release to start fabrication and welding.',
            'weeks': 8
        },
    ],
    paymentTerms: "",
    scope: "",
    quoteValidityDays: "",
    validity: "",
    conditionsOfSale: "",
    POAddress: "",
    cancellation: "",
    forceMajeure: "",
    confidentiality: "",
    previousOrder: false,
    previousOrderInfo: "",
    approvalDrawings: true,
    loadLeadTime: false,
    prevFiles: [],
    taxFiles: [],
    dropFiles: []
}

let idcount = 1
mixerFormData.mixers.forEach((mixer) => {
    mixerFormData[`${mixer}_name`] = 'Mixer ' + idcount
    mixerFormData[`${mixer}_cases`] = initialSetup['cases']
    mixerFormData[`${mixer}_streams`] = initialSetup['streams']
    mixerFormData[`${mixer}_caseCount`] = initialSetup['caseCount']
    mixerFormData[`${mixer}_streamCount`] = initialSetup['streamCount']

    idcount = idcount + 1
    Object.entries(MixerFieldTemplate).forEach(([key, label]) => {
        mixerFormData[`${mixer}_${key}`]= label
    })

    let streamIDCount = 1
    mixerFormData[`${mixer}_streams`].forEach((stream) => {
        mixerFormData[`${mixer}_${stream}_name`] = 'Stream ' + streamIDCount
        streamIDCount = streamIDCount + 1
    })

    let caseIDCount = 1
    mixerFormData[`${mixer}_cases`].forEach((Fcase) => {
        mixerFormData[`${mixer}_${Fcase}_name`] = 'Case ' + caseIDCount
        caseFields[mixerFormData[`${mixer}_application`]].forEach((Cfield) => {
            mixerFormData[`${mixer}_${Fcase}_${Cfield}`] = ''
            mixerFormData[`${mixer}_streams`].forEach((stream) => {
                streamFields[mixerFormData[`${mixer}_application`]].forEach((Sfield) => {
                    mixerFormData[`${mixer}_${Fcase}_${stream}_${Sfield}`] = ''
                })
                Object.entries(streamUnits).forEach(([key, label]) => {
                    mixerFormData[`${mixer}_${stream}_${key}`] = label
                })
            })
        })
        caseSimFields.forEach((csField) => {
            mixerFormData[`${mixer}_${Fcase}_${csField}`] = ''
        })
        caseIDCount = caseIDCount + 1
    })
})

function standardValidate(appState){
    let bool = true
    appState.mixers.forEach((mixer) => {
        Object.entries(MixerNonStandard).forEach(([field, list]) => {
            if(field === 'options'){
                list.forEach((option) => {
                    if(appState[`${mixer}_${option}`]){
                        bool = false
                    }
                })
            }else if(field === 'tubing'){
                Object.entries(list).forEach(([tField, tList]) => {
                    if(tList.includes(appState[`${mixer}_${tField}`]) && appState[`${mixer}_pipeSch`] === 'Tubing (Standard)'){
                        bool = false
                    }
                })
            }else if(list.includes(appState[`${mixer}_${field}`])){
                bool = false
            }
        })
    })
    return bool
}

const reducer = (state, action) => {
    switch (action.type) {
        case "change":
            const id = action.name
            const value = action.value

            const mixerFields = ['size','mixerElement','elementsNumber','fixedRemove','elementMoc','elementsOnly','pipeSch','flangeRating','endConType','sideConSize','sideConType','housingMoc','orientation','designPressure','designTemperature','corrosionAllow','designCode','purchaseHousing','picklePassivate','shipPrimer','specialPaint','hydroTest','rt','lpt','pmi','mpt','hardnessTesting','impactTesting','pwht','asmeStamp','peStamp','CRN']

            let standBool = standardValidate({...state, [id]: value})

            let qType
            if(standBool){
                qType = 'Quote'
            }else{
                qType = 'Request'
            }

            let newStatus
            if(id === 'status'){
                newStatus = value
            }else{
                newStatus = state.status
            }
            
            if(qType === 'Request'){
                newStatus = 'Draft'
            }else if(newStatus === 'Current' && mixerFields.includes(id.split('_')[1])){
                newStatus = 'Update Pricing'
            }

            // update lead time
            const leadFields = {
                'mixer': ['size', 'mixerElement', 'picklePassivate', 'electropolish', 'asmeStamp', 'elementsOnly', 'elementMoc', 'flangeRating'],
                'overall': ['previousOrder', 'approvalDrawings']
            }

            let loadLeadTime = false
            if(leadFields.mixer.includes(id.split('_')[1]) || leadFields.overall.includes(id) && qType !== 'Request'){
                loadLeadTime = true
            }

            return {...state, [id]: value, 'isStandard': standBool, 'loadLeadTime': loadLeadTime, 'type': qType, 'status': newStatus};
        case "addFile":
            const fileAddID = action.id
            const addType = action.addType
            
            var fileObj = {}
            if(addType === 'new'){
                const file = new File([action.value], action.filename, {type: action.contenttype})
                fileObj = {'file': file, 'addType': addType, 'name': action.filename, 'size': action.size, 'fileType': action.fileType}
            }else{
                fileObj = {'name': action.filename, 'addType': addType, 'size': action.size, 'fileType': action.fileType}
            }
            
            let stateFiles = state[`${fileAddID}`]

            stateFiles.push(fileObj)

            return {...state, [fileAddID]: stateFiles};
        case "deleteFile":
            const fileDelID = action.id
            const filename = action.filename
            let newStateFiles = state[`${fileDelID}`].filter(f => f.name !== filename)

            return {...state, [fileDelID]: newStateFiles};
        case "addMixer":
            const newMixerList = [...state.mixers]
            let mixerid = parseInt(newMixerList.slice(-1)[0].slice(-1)) + 1
            const newMixerID = 'mixer' + mixerid

            newMixerList.push(newMixerID)

            const newMixerState = {}
            newMixerState[`${newMixerID}_name`] = 'Mixer ' + mixerid
            newMixerState[`${newMixerID}_cases`] = initialSetup['cases']
            newMixerState[`${newMixerID}_streams`] = initialSetup['streams']
            newMixerState[`${newMixerID}_caseCount`] = initialSetup['caseCount']
            newMixerState[`${newMixerID}_streamCount`] = initialSetup['streamCount']

            Object.entries(MixerFieldTemplate).forEach(([key, label]) => {
                newMixerState[`${newMixerID}_${key}`]= label
            })

            let streamIDCount = 1
            newMixerState[`${newMixerID}_streams`].forEach((stream) => {
                newMixerState[`${newMixerID}_${stream}_name`] = 'Stream ' + streamIDCount
                streamIDCount = streamIDCount + 1
            })

            let caseIDCount = 1
            newMixerState[`${newMixerID}_cases`].forEach((Fcase) => {
                newMixerState[`${newMixerID}_${Fcase}_name`] = 'Case ' + caseIDCount
                caseFields[newMixerState[`${newMixerID}_application`]].forEach((Cfield) => {
                    newMixerState[`${newMixerID}_${Fcase}_${Cfield}`] = ''
                    newMixerState[`${newMixerID}_streams`].forEach((stream) => {
                        streamFields[newMixerState[`${newMixerID}_application`]].forEach((Sfield) => {
                            newMixerState[`${newMixerID}_${Fcase}_${stream}_${Sfield}`] = ''
                        })
                        Object.entries(streamUnits).forEach(([key, label]) => {
                            newMixerState[`${newMixerID}_${stream}_${key}`] = label
                        })
                    })
                })
                caseSimFields.forEach((csField) => {
                    newMixerState[`${newMixerID}_${Fcase}_${csField}`] = ''
                })
                caseIDCount = caseIDCount + 1
            })

            return {...state, ...newMixerState, 'mixers': newMixerList, 'mixercount': mixerid, 'status': 'Update Pricing', 'alertState': true, 'alertSeverity': 'success', 'alertContent': "New mixer added"}
        case "copyMixer":
            const copyMixerID = action.copymixerid
            const copyMixerList = [...state.mixers]
            let copymixerid = parseInt(copyMixerList.slice(-1)[0].slice(-1)) + 1
            const newCopyMixerID = 'mixer' + copymixerid

            copyMixerList.push(newCopyMixerID)

            const copyMixerState = {}
            copyMixerState[`${newCopyMixerID}_name`] = 'Mixer ' + copymixerid
            copyMixerState[`${newCopyMixerID}_cases`] = state[`${copyMixerID}_cases`]
            copyMixerState[`${newCopyMixerID}_streams`] = state[`${copyMixerID}_streams`]
            copyMixerState[`${newCopyMixerID}_caseCount`] = state[`${copyMixerID}_caseCount`]
            copyMixerState[`${newCopyMixerID}_streamCount`] = state[`${copyMixerID}_streamCount`]

            Object.entries(MixerFieldTemplate).forEach(([key, label]) => {
                copyMixerState[`${newCopyMixerID}_${key}`]= state[`${copyMixerID}_${key}`]
            })

            copyMixerState[`${newCopyMixerID}_streams`].forEach((stream) => {
                copyMixerState[`${newCopyMixerID}_${stream}_name`] = state[`${copyMixerID}_${stream}_name`]
            })

            copyMixerState[`${newCopyMixerID}_cases`].forEach((Fcase) => {
                copyMixerState[`${newCopyMixerID}_${Fcase}_name`] = state[`${copyMixerID}_${Fcase}_name`]
                caseFields[copyMixerState[`${newCopyMixerID}_application`]].forEach((Cfield) => {
                    copyMixerState[`${newCopyMixerID}_${Fcase}_${Cfield}`] = state[`${copyMixerID}_${Fcase}_${Cfield}`]
                    copyMixerState[`${newCopyMixerID}_streams`].forEach((stream) => {
                        streamFields[copyMixerState[`${newCopyMixerID}_application`]].forEach((Sfield) => {
                            copyMixerState[`${newCopyMixerID}_${Fcase}_${stream}_${Sfield}`] = state[`${copyMixerID}_${Fcase}_${stream}_${Sfield}`]
                        })
                        Object.entries(streamUnits).forEach(([key, label]) => {
                            copyMixerState[`${newCopyMixerID}_${stream}_${key}`] = state[`${copyMixerID}_${stream}_${key}`]
                        })
                    })
                })
                caseSimFields.forEach((csField) => {
                    copyMixerState[`${newCopyMixerID}_${Fcase}_${csField}`] = state[`${copyMixerID}_${Fcase}_${csField}`]
                })
            })

            return {...state, ...copyMixerState, 'mixers': copyMixerList, 'mixercount': copymixerid, 'status': 'Update Pricing', 'alertState': true, 'alertSeverity': 'success', 'alertContent': "New mixer added"}
        case "AddSpares":
            const spareMixerID = action.mixerid
            const spareMixerList = [...state.mixers]
            let sparemixerid = parseInt(spareMixerList.slice(-1)[0].slice(-1)) + 1
            const newSpareMixerID = 'mixer' + sparemixerid

            spareMixerList.push(newSpareMixerID)

            const spareMixerState = {}
            spareMixerState[`${newSpareMixerID}_name`] = 'Spare Elements For ' + state[`${spareMixerID}_name`]
            spareMixerState[`${newSpareMixerID}_cases`] = state[`${spareMixerID}_cases`]
            spareMixerState[`${newSpareMixerID}_streams`] = state[`${spareMixerID}_streams`]
            spareMixerState[`${newSpareMixerID}_caseCount`] = state[`${spareMixerID}_caseCount`]
            spareMixerState[`${newSpareMixerID}_streamCount`] = state[`${spareMixerID}_streamCount`]

            Object.entries(MixerFieldTemplate).forEach(([key, label]) => {
                spareMixerState[`${newSpareMixerID}_${key}`]= state[`${spareMixerID}_${key}`]
            })
            spareMixerState[`${newSpareMixerID}_sideCon`] = false
            spareMixerState[`${newSpareMixerID}_elementsOnly`] = true
            spareMixerState[`${newSpareMixerID}_flangeRating`] = ''
            spareMixerState[`${newSpareMixerID}_endConType`] = ''
            spareMixerState[`${newSpareMixerID}_sideCon`] = false
            spareMixerState[`${newSpareMixerID}_sideConSize`] = ''
            spareMixerState[`${newSpareMixerID}_sideConType`] = ''
            spareMixerState[`${newSpareMixerID}_housingMoc`] = ''
            spareMixerState[`${newSpareMixerID}_housingMocOther`] = ''
            spareMixerState[`${newSpareMixerID}_priceUnit`] = 0
            spareMixerState[`${newSpareMixerID}_length`] = 0
            spareMixerState[`${newSpareMixerID}_weight`] = 0

            spareMixerState[`${newSpareMixerID}_streams`].forEach((stream) => {
                spareMixerState[`${newSpareMixerID}_${stream}_name`] = state[`${spareMixerID}_${stream}_name`]
            })

            spareMixerState[`${newSpareMixerID}_cases`].forEach((Fcase) => {
                spareMixerState[`${newSpareMixerID}_${Fcase}_name`] = state[`${spareMixerID}_${Fcase}_name`]
                caseFields[spareMixerState[`${newSpareMixerID}_application`]].forEach((Cfield) => {
                    spareMixerState[`${newSpareMixerID}_${Fcase}_${Cfield}`] = state[`${spareMixerID}_${Fcase}_${Cfield}`]
                    spareMixerState[`${newSpareMixerID}_streams`].forEach((stream) => {
                        streamFields[spareMixerState[`${newSpareMixerID}_application`]].forEach((Sfield) => {
                            spareMixerState[`${newSpareMixerID}_${Fcase}_${stream}_${Sfield}`] = state[`${spareMixerID}_${Fcase}_${stream}_${Sfield}`]
                        })
                        Object.entries(streamUnits).forEach(([key, label]) => {
                            spareMixerState[`${newSpareMixerID}_${stream}_${key}`] = state[`${spareMixerID}_${stream}_${key}`]
                        })
                    })
                })
                caseSimFields.forEach((csField) => {
                    spareMixerState[`${newSpareMixerID}_${Fcase}_${csField}`] = state[`${spareMixerID}_${Fcase}_${csField}`]
                })
            })

            return {...state, ...spareMixerState, 'mixers': spareMixerList, 'mixercount': sparemixerid, 'status': 'Update Pricing', 'alertState': true, 'alertSeverity': 'success', 'alertContent': "New mixer added", 'sparesPurchased': true}
        case "removeMixer":
            const delMixer = action.mixerid
            let mixerList = state.mixers.filter(mixer => !mixer.includes(delMixer))
            let newDelState = Object.keys(state)
                .filter(item => !item.includes(delMixer))
                .reduce((obj, key) => {
                    obj[key] = state[key];
                    return obj;
                }, {});

            return {...newDelState, 'mixers': mixerList, 'status': 'Update Pricing', 'alertState': true, 'alertSeverity': 'success', 'alertContent': `${state[`${delMixer}_name`]} has been removed`}
        case "addCase":
            let newMixerid = action.mixerid
            let newCaseList = [...state[`${newMixerid}_cases`]]
            let caseCount = parseInt(newCaseList.slice(-1)[0].slice(-1)) + 1
            let newCaseID = 'case' + caseCount
            let newColSpan = state[`${newMixerid}_colSpan`] + 1

            newCaseList.push(newCaseID)

            let newCMixerState ={}

            newCMixerState[`${newMixerid}_cases`]= newCaseList

            newCMixerState[`${newMixerid}_${newCaseID}_name`] = 'Case ' + caseCount
                caseFields[state[`${newMixerid}_application`]].forEach((Cfield) => {
                    newCMixerState[`${newMixerid}_${newCaseID}_${Cfield}`] = ''
                    state[`${newMixerid}_streams`].forEach((stream) => {
                        streamFields[state[`${newMixerid}_application`]].forEach((Sfield) => {
                            newCMixerState[`${newMixerid}_${newCaseID}_${stream}_${Sfield}`] = ''
                        })
                    })
                })
                caseSimFields.forEach((csField) => {
                    newCMixerState[`${newMixerid}_${newCaseID}_${csField}`] = ''
                })

            return{...state, ...newCMixerState, [`${newMixerid}_colSpan`]: newColSpan, [`${newMixerid}_caseCount`]: caseCount, 'alertState': true, 'alertSeverity': 'success', 'alertContent': `New case added to ${state[`${newMixerid}_name`]}`}
        case "copyCase":
            let copyMixerid = action.mixerid
            let caseid = action.caseid
            let copyCaseList = [...state[`${copyMixerid}_cases`]]
            let copyCaseCount = parseInt(copyCaseList.slice(-1)[0].slice(-1)) + 1
            let copyCaseID = 'case' + copyCaseCount
            let copyColSpan = state[`${copyMixerid}_colSpan`] + 1

            copyCaseList.push(copyCaseID)

            let copyCMixerState ={}

            copyCMixerState[`${copyMixerid}_cases`]= copyCaseList

            copyCMixerState[`${copyMixerid}_${copyCaseID}_name`] = 'Case ' + copyCaseCount
                caseFields[state[`${copyMixerid}_application`]].forEach((Cfield) => {
                    copyCMixerState[`${copyMixerid}_${copyCaseID}_${Cfield}`] = state[`${copyMixerid}_${caseid}_${Cfield}`]
                    state[`${copyMixerid}_streams`].forEach((stream) => {
                        streamFields[state[`${copyMixerid}_application`]].forEach((Sfield) => {
                            copyCMixerState[`${copyMixerid}_${copyCaseID}_${stream}_${Sfield}`] =  state[`${copyMixerid}_${caseid}_${stream}_${Sfield}`]
                        })
                    })
                })
                caseSimFields.forEach((csField) => {
                    copyCMixerState[`${copyMixerid}_${copyCaseID}_${csField}`] = ''
                })

            return{...state, ...copyCMixerState, [`${copyMixerid}_colSpan`]: copyColSpan, [`${copyMixerid}_caseCount`]: copyCaseCount, 'alertState': true, 'alertSeverity': 'success', 'alertContent': `New case added to ${state[`${copyMixerid}_name`]}`}
        case "removeCase":
            let delCaseid = action.caseid
            let cDelMixerID = action.mixerid
            let newCaseColSpan = state[`${cDelMixerID}_colSpan`] - 1
            let delCase = `${cDelMixerID}_${delCaseid}`
            let caseList = state[`${cDelMixerID}_cases`].filter(Fcase => !Fcase.includes(delCaseid))

            let newCDelState = Object.keys(state)
                .filter(item => !item.includes(delCase))
                .reduce((obj, key) => {
                    obj[key] = state[key];
                    return obj;
                }, {});

            return {...newCDelState, [`${cDelMixerID}_cases`]: caseList, [`${cDelMixerID}_colSpan`]: newCaseColSpan, 'alertState': true, 'alertSeverity': 'success', 'alertContent': `${state[`${delCase}_name`]} has been removed from ${state[`${cDelMixerID}_name`]}`}
        case "addStream":
            let newSMixerid = action.mixerid
            let newStreamList = [...state[`${newSMixerid}_streams`]]
            let streamCount = parseInt(newStreamList.slice(-1)[0].slice(-1)) + 1
            let newStreamID = 'stream' + streamCount

            newStreamList.push(newStreamID)

            let newSMixerState ={}

            newSMixerState[`${newSMixerid}_${newStreamID}_name`] = 'Stream ' + streamCount

            state[`${newSMixerid}_cases`].forEach((Fcase) => {
                streamFields[state[`${newSMixerid}_application`]].forEach((Sfield) => {
                    newSMixerState[`${newSMixerid}_${Fcase}_${newStreamID}_${Sfield}`] = ''
                })
            })
            
            Object.entries(streamUnits).forEach(([key, label]) => {
                newSMixerState[`${newSMixerid}_${newStreamID}_${key}`] = label
            })

            return{...state, ...newSMixerState, [`${newSMixerid}_streams`]: newStreamList, [`${newSMixerid}_streamCount`]: streamCount, 'alertState': true, 'alertSeverity': 'success', 'alertContent': `New stream added to ${state[`${newSMixerid}_name`]}`}
        case "copyStream":
            let copySMixerid = action.mixerid
            let streamid = action.streamid
            let copyStreamList = [...state[`${copySMixerid}_streams`]]
            let copyStreamCount = parseInt(copyStreamList.slice(-1)[0].slice(-1)) + 1
            let copyStreamID = 'Stream' + copyStreamCount

            copyStreamList.push(copyStreamID)

            let copySMixerState ={}

            copySMixerState[`${copySMixerid}_${copyStreamID}_name`] = 'Stream ' + copyStreamCount

            state[`${copySMixerid}_cases`].forEach((FCase) => {
                streamFields[state[`${copySMixerid}_application`]].forEach((Sfield) => {
                    copySMixerState[`${copySMixerid}_${FCase}_${copyStreamID}_${Sfield}`] = state[`${copySMixerid}_${FCase}_${streamid}_${Sfield}`]
                })
            })
            Object.entries(streamUnits).forEach(([key, label]) => {
                copySMixerState[`${copySMixerid}_${copyStreamID}_${key}`] = state[`${copySMixerid}_${streamid}_${key}`]
            })

            return{...state, ...copySMixerState, [`${copySMixerid}_streams`]: copyStreamList, [`${copySMixerid}_StreamCount`]: copyStreamCount, 'alertState': true, 'alertSeverity': 'success', 'alertContent': `New stream added to ${state[`${copySMixerid}_name`]}`}
        case "removeStream":
            let delStreamid = action.streamid
            let sDelMixerID = action.mixerid
            let streamList = state[`${sDelMixerID}_streams`].filter(stream => !stream.includes(delStreamid))

            let newSDelState = Object.keys(state)
                .filter(item => !item.includes(delStreamid) || !item.includes(sDelMixerID))
                .reduce((obj, key) => {
                    obj[key] = state[key];
                    return obj;
                }, {});

            return {...newSDelState, [`${sDelMixerID}_streams`]: streamList, 'alertState': true, 'alertSeverity': 'success', 'alertContent': `${state[`${sDelMixerID}_${delStreamid}_name`]} has been removed ${state[`${sDelMixerID}_name`]}`}
        case "quoteProcess":
            let quoteData = action.response

            let standardBool
            if(quoteData['quote']['type'] === 'Quote'){
                standardBool = true
            }else{
                standardBool = false
            }

            let newQuoteState = {
                mixers: quoteData['mixers'],
                mixercount: quoteData['mixers'].length,
                quote_id: quoteData['quote']['quote_id'],
                quote_name: quoteData['quote']['name'],
                type: quoteData['quote']['type'],
                isSaved: true,
                isStandard: standardBool,
                status: quoteData['quote']['status'],
                sparesPurchased: quoteData['quote']['sparesPurchased'],
                issue_date: quoteData['quote']['issue_date'],
                expire_date: quoteData['quote']['expire_date'],
                need_date: need_date.toISOString().split('T')[0],
                last_save_date: quoteData['quote']['last_save_date'],
                alertState: false,
                alertContent: "",
                alertSeverity:"success",
                add_notes: {editorHtml: ''},
                dropFiles: [],
                manufactureTerms: quoteData['quote']['manufactureTerms'],
                shippingTerms: mixerFormData['shippingTerms'],
                paymentTerms: quoteData['quote']['paymentTerms'],
                scope: quoteData['quote']['scope'],
                quoteValidityDays: quoteData['quote']['quoteValidityDays'],
                validity: quoteData['quote']['validity'],
                conditionsOfSale: quoteData['quote']['conditionsOfSale'],
                POAddress: quoteData['quote']['POAddress'],
                cancellation: quoteData['quote']['cancellation'],
                forceMajeure: quoteData['quote']['forceMajeure'],
                confidentiality: quoteData['quote']['confidentiality'],
                loadLeadTime: true
            }

            if(quoteData['quote']['need_date'] !== null){
                newQuoteState['need_date'] = quoteData['quote']['need_date']
            }

            if(quoteData['quote']['add_notes'] !== null){
                newQuoteState['add_notes'] = {editorHtml: quoteData['quote']['add_notes']}
            }

            let SMVPresent = false
            quoteData['mixers'].forEach((mixer) =>{
                //set up new mixer state
                Object.entries(MixerFieldTemplate).forEach(([key, label]) => {
                    if(quoteData[`${mixer}`][`${key}`] !== null){
                        newQuoteState[`${mixer}_${key}`] = quoteData[`${mixer}`][`${key}`]
                    }else{
                        newQuoteState[`${mixer}_${key}`] = label
                    }
                })

                if(quoteData[`${mixer}`]['mixerElement'] === 'SMV'){
                    SMVPresent = true
                }
                newQuoteState[`${mixer}_tabState`] = 0
                newQuoteState[`${mixer}_name`] = quoteData[`${mixer}`]['name']
                newQuoteState[`${mixer}_colSpan`] = quoteData[`${mixer}_cases`].length + 1
                newQuoteState[`${mixer}_cases`] = quoteData[`${mixer}_cases`]
                newQuoteState[`${mixer}_caseCount`] = quoteData[`${mixer}_cases`].length
                newQuoteState[`${mixer}_streams`] = quoteData[`${mixer}_streams`]
                newQuoteState[`${mixer}_streamCount`] = quoteData[`${mixer}_streams`].length
                newQuoteState[`${mixer}_validErrors`] = {}

                quoteData[`${mixer}_cases`].forEach((Fcase) => {
                    newQuoteState[`${mixer}_${Fcase}_name`] = quoteData[`${mixer}_${Fcase}`]['name']
                    caseSimFields.forEach((csField) => {
                        if(quoteData[`${mixer}_${Fcase}`][`${csField}`] !== null){
                            newQuoteState[`${mixer}_${Fcase}_${csField}`] = quoteData[`${mixer}_${Fcase}`][`${csField}`]
                        }else{
                            newQuoteState[`${mixer}_${Fcase}_${csField}`] = ''
                        }
                    })
                    caseFields[quoteData[`${mixer}`]['application']].forEach((Cfield) => {
                        if(quoteData[`${mixer}_${Fcase}`][`${Cfield}`] !== null){
                            newQuoteState[`${mixer}_${Fcase}_${Cfield}`] = quoteData[`${mixer}_${Fcase}`][`${Cfield}`]
                        }else{
                            newQuoteState[`${mixer}_${Fcase}_${Cfield}`] = ''
                        }
                        quoteData[`${mixer}_streams`].forEach((stream) => {
                            newQuoteState[`${mixer}_${stream}_name`] = quoteData[`${mixer}_${Fcase}_${stream}`]['name']
                            streamFields[quoteData[`${mixer}`]['application']].forEach((Sfield) => {
                                if(quoteData[`${mixer}_${Fcase}_${stream}`][`${Sfield}`] !== null){
                                    newQuoteState[`${mixer}_${Fcase}_${stream}_${Sfield}`] = quoteData[`${mixer}_${Fcase}_${stream}`][`${Sfield}`]
                                }else{
                                    newQuoteState[`${mixer}_${Fcase}_${stream}_${Sfield}`] = ''
                                }
                            })
                            Object.entries(streamUnits).forEach(([key, label]) => {
                                if(quoteData[`${mixer}_${Fcase}_${stream}`][`${key}`] !== null){
                                    newQuoteState[`${mixer}_${stream}_${key}`] = quoteData[`${mixer}_${Fcase}_${stream}`][`${key}`]
                                }else{
                                    newQuoteState[`${mixer}_${stream}_${key}`] = label
                                }
                            })
                        })
                    })
                })
            })

            newQuoteState['SMVPresent'] = SMVPresent

            return {...state, ...newQuoteState}
        case "quoteCopy":
            let quoteDataCopy = action.response

            let newQuoteStateCopy = {
                mixers: quoteDataCopy['mixers'],
                mixercount: quoteDataCopy['mixers'].length,
                sparesPurchased: quoteDataCopy['quote']['sparesPurchased'],
                manufactureTerms: quoteDataCopy['quote']['manufactureTerms'],
                shippingTerms: mixerFormData['shippingTerms'],
                paymentTerms: quoteDataCopy['quote']['paymentTerms'],
                scope: quoteDataCopy['quote']['scope'],
                validity: quoteDataCopy['quote']['validity'],
                conditionsOfSale: quoteDataCopy['quote']['conditionsOfSale'],
                POAddress: quoteDataCopy['quote']['POAddress'],
                cancellation: quoteDataCopy['quote']['cancellation'],
                forceMajeure: quoteDataCopy['quote']['forceMajeure'],
                confidentiality: quoteDataCopy['quote']['confidentiality']
            }

            let SMVPresentCopy = false
            quoteDataCopy['mixers'].forEach((mixer) =>{
                //set up new mixer state
                Object.entries(MixerFieldTemplate).forEach(([key, label]) => {
                    if(quoteDataCopy[`${mixer}`][`${key}`] !== null){
                        newQuoteStateCopy[`${mixer}_${key}`] = quoteDataCopy[`${mixer}`][`${key}`]
                    }else{
                        newQuoteStateCopy[`${mixer}_${key}`] = label
                    }
                })

                if(quoteDataCopy[`${mixer}`]['mixerElement'] === 'SMV'){
                    SMVPresentCopy = true
                }

                newQuoteStateCopy[`${mixer}_tabState`] = 0
                newQuoteStateCopy[`${mixer}_name`] = quoteDataCopy[`${mixer}`]['name']
                newQuoteStateCopy[`${mixer}_colSpan`] = quoteDataCopy[`${mixer}_cases`].length + 1
                newQuoteStateCopy[`${mixer}_cases`] = quoteDataCopy[`${mixer}_cases`]
                newQuoteStateCopy[`${mixer}_caseCount`] = quoteDataCopy[`${mixer}_cases`].length
                newQuoteStateCopy[`${mixer}_streams`] = quoteDataCopy[`${mixer}_streams`]
                newQuoteStateCopy[`${mixer}_streamCount`] = quoteDataCopy[`${mixer}_streams`].length
                newQuoteStateCopy[`${mixer}_validErrors`] = {}
                newQuoteStateCopy[`${mixer}_priceUnit`] = 0

                quoteDataCopy[`${mixer}_cases`].forEach((Fcase) => {
                    newQuoteStateCopy[`${mixer}_${Fcase}_name`] = quoteDataCopy[`${mixer}_${Fcase}`]['name']
                    caseSimFields.forEach((csField) => {
                        if(quoteDataCopy[`${mixer}_${Fcase}`][`${csField}`] !== null){
                            newQuoteStateCopy[`${mixer}_${Fcase}_${csField}`] = quoteDataCopy[`${mixer}_${Fcase}`][`${csField}`]
                        }else{
                            newQuoteStateCopy[`${mixer}_${Fcase}_${csField}`] = ''
                        }
                    })
                    caseFields[quoteDataCopy[`${mixer}`]['application']].forEach((Cfield) => {
                        if(quoteDataCopy[`${mixer}_${Fcase}`][`${Cfield}`] !== null){
                            newQuoteStateCopy[`${mixer}_${Fcase}_${Cfield}`] = quoteDataCopy[`${mixer}_${Fcase}`][`${Cfield}`]
                        }else{
                            newQuoteStateCopy[`${mixer}_${Fcase}_${Cfield}`] = ''
                        }
                        quoteDataCopy[`${mixer}_streams`].forEach((stream) => {
                            newQuoteStateCopy[`${mixer}_${stream}_name`] = quoteDataCopy[`${mixer}_${Fcase}_${stream}`]['name']
                            streamFields[quoteDataCopy[`${mixer}`]['application']].forEach((Sfield) => {
                                if(quoteDataCopy[`${mixer}_${Fcase}_${stream}`][`${Sfield}`] !== null){
                                    newQuoteStateCopy[`${mixer}_${Fcase}_${stream}_${Sfield}`] = quoteDataCopy[`${mixer}_${Fcase}_${stream}`][`${Sfield}`]
                                }else{
                                    newQuoteStateCopy[`${mixer}_${Fcase}_${stream}_${Sfield}`] = ''
                                }
                            })
                            Object.entries(streamUnits).forEach(([key, label]) => {
                                if(quoteDataCopy[`${mixer}_${Fcase}_${stream}`][`${key}`] !== null){
                                    newQuoteStateCopy[`${mixer}_${stream}_${key}`] = quoteDataCopy[`${mixer}_${Fcase}_${stream}`][`${key}`]
                                }else{
                                    newQuoteStateCopy[`${mixer}_${stream}_${key}`] = label
                                }
                            })
                        })
                    })
                })
            })

            newQuoteStateCopy['SMVPresent'] = SMVPresentCopy

            return {...state, ...newQuoteStateCopy}
        case "resetState":
            return {...mixerFormData}
        case "newQuoteProcess":
            const authData = action.authData
            
            const newQuoteProcessState = {
                manufactureTerms: authData['manufactureTerms'],
                shippingTerms: mixerFormData['shippingTerms'],
                paymentTerms: authData['paymentTerms'],
                scope: authData['scope'],
                validity: authData['validity'],
                conditionsOfSale: authData['conditionsOfSale'],
                POAddress: authData['POAddress'],
                cancellation: authData['cancellation'],
                forceMajeure: authData['forceMajeure'],
                confidentiality: authData['confidentiality']
            }

            return {...mixerFormData, ...newQuoteProcessState}
        default:
            return {...state}
    }
}

export const MixerDataProvider = (props) => {
    const initialState = mixerFormData

    const [formData, dispatch] = useReducer(reducer, initialState)

    const value = { formData, dispatch }

    return <MixerDesignContext.Provider value={value}>{props.children}</MixerDesignContext.Provider>
}